module.exports = __webpack_public_path__ + "static/media/MtSutro.a853661a.gif";